import React from 'react';
import { useAppContext } from '../../context/AppContext';

export const GlobalAnnouncement: React.FC = () => {
    const { db } = useAppContext();
    const announcement = db.globalConfig?.globalAnnouncement;

    if (!announcement?.active || !announcement.message) return null;

    const getColors = () => {
        switch (announcement.type) {
            case 'danger':
                return 'bg-red-500/10 border-red-500/20 text-red-500';
            case 'warning':
                return 'bg-amber-500/10 border-amber-500/20 text-amber-500';
            case 'info':
            default:
                return 'bg-blue-500/10 border-blue-500/20 text-blue-500';
        }
    };

    const getIcon = () => {
        switch (announcement.type) {
            case 'danger': return 'error';
            case 'warning': return 'warning';
            case 'info': default: return 'info';
        }
    };

    return (
        <div className={`mx-4 mt-2 px-4 py-3 rounded-lg border flex items-center gap-3 ${getColors()}`}>
            <span className="material-symbols-outlined text-[20px]">{getIcon()}</span>
            <span className="text-sm font-medium">{announcement.message}</span>
        </div>
    );
};
